import { render, staticRenderFns } from "./PingShenUser.vue?vue&type=template&id=f60bf54c&scoped=true"
import script from "./PingShenUser.vue?vue&type=script&lang=js"
export * from "./PingShenUser.vue?vue&type=script&lang=js"
import style0 from "./PingShenUser.vue?vue&type=style&index=0&id=f60bf54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60bf54c",
  null
  
)

export default component.exports